import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Container,
  CloseButton,
  DisclosureIcon,
  Content,
  DisclosureText,
  CloseIcon,
  DisclosuresContainer,
  Disclosures,
  StyledDisclosureTitle,
  StyledDisclosureValue
} from './Styles';

import BaseModal from '../../../../_shared/components/BaseModal';
import useEscModalTracking from '../../../../_shared/hooks/useEscModalTracking';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  disclosure: PropTypes.string.isRequired
};

const ConditionDisclosureOverlay = ({ isOpen, closeModal, disclosure }) => {
  useEscModalTracking('VDP-checklist', isOpen);
  let mergedDisclosures;
  if (disclosure && (disclosure.disclosures || disclosure.invalidDisclosures)) {
    mergedDisclosures = [
      ...disclosure.disclosures,
      ...disclosure.invalidDisclosures
    ];
    mergedDisclosures.sort((a, b) => {
      return a.localeCompare(b);
    });
    mergedDisclosures = mergedDisclosures.map(disc => {
      if (disclosure.disclosures && disclosure.disclosures.indexOf(disc) > -1) {
        return { disc, valid: 'YES' };
      }
      return { disc, valid: 'NO' };
    });
  }

  return (
    <BaseModal
      isOpen={isOpen}
      width={438}
      padding="0px 24px 24px"
      isClickOverlayClose
      isClickEscClose
      bodyOpenClassName="ReactModal__Checklist"
      isFullScreen={false}
      onRequestClose={closeModal}
    >
      <Container>
        <CloseButton onClick={closeModal}>
          {/* CLOSE */}
          <FormattedMessage id="vdp.close" />
          <CloseIcon />
        </CloseButton>
        <Content>
          <DisclosureIcon icon={`TR5-${disclosure.type}`} />
          {disclosure.type} checklist
          <DisclosureText>
            The person inspecting this vehicle was asked to indicate yes or no
            for each item on this checklist.
          </DisclosureText>
          {mergedDisclosures && (
            <DisclosuresContainer>
              {mergedDisclosures.map(disc => {
                return (
                  <Disclosures key={disc}>
                    <StyledDisclosureTitle invalid={disc.valid}>
                      {disc.disc}
                    </StyledDisclosureTitle>
                    <StyledDisclosureValue invalid={disc.valid}>
                      {disc.valid}
                    </StyledDisclosureValue>
                  </Disclosures>
                );
              })}
            </DisclosuresContainer>
          )}
        </Content>
      </Container>
    </BaseModal>
  );
};

ConditionDisclosureOverlay.propTypes = propTypes;

export default ConditionDisclosureOverlay;
